<template>
	<el-tabs type="border-card" class="h-100 no-scroll" @tab-click="handleClick">
		<el-tab-pane class="mt-3" v-for="(menu, index) in tabMenuList" :key="index" :label="menu.name">
			<component
				:is="menu.tag"
				class="px-3 pb-2"
				:scrId="scrId"
				:tab1="tab1"
				:tab2="tab2"
			></component>
		</el-tab-pane>

	</el-tabs>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/clma/PcPcm/store/helpers';
import PcPcmTapFlc from './PcPcmTapFlc/PcPcmTapFlc.vue';
import PcPcmTapKd from './PcPcmTapKd/PcPcmTapKd.vue';

export default {
	props: {
		scrId: { type: String, default: '' },
		tab1: { type: String, default: '' },
		tab2: { type: String, default: '' },
	},
	data() {
		return {
			tabMenuList: [
				{ tag: 'pc-pcm-tap-flc', name: this.tab1},
				{ tag: 'pc-pcm-tap-kd', name: this.tab2}
			]
		};
	},
	components: { PcPcmTapFlc, PcPcmTapKd },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		handleClick(tab) {
		if(tab.index === "0"){
			this.setState_({ key: 'isLoading1', value: true })
		}else if(tab.index === "1"){
			this.setState_({ key: 'isLoading2', value: true })
		}
      }	
	}
};
</script>
